/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Linked_YesInputs */

const vi_shop_account_linked_yes = /** @type {(inputs: Shop_Account_Linked_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã liên kết`)
};

/**

* @param {Shop_Account_Linked_YesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_linked_yes = /** @type {((inputs?: Shop_Account_Linked_YesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Linked_YesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_linked_yes(inputs)
});